import { Injectable, TemplateRef, ComponentRef, ViewContainerRef } from '@angular/core';
import { CsqLogoTemplateComponent } from './csq-logo-template.component';

@Injectable({
  providedIn: 'root',
})
export class CsqLogoService {
  createCsqLogoTemplate(viewContainerRef: ViewContainerRef): TemplateRef<any> {
    const componentRef: ComponentRef<CsqLogoTemplateComponent> = viewContainerRef.createComponent(CsqLogoTemplateComponent);
    return componentRef.instance.csqLogoTemplate;
  }
}
